<template>
    <div class="form-small">
      <div class="text-center logo-login">
        <img src="../../images/home/nextempleamar-logo.png" width="197" alt="NextempeleaMar" />
      </div>
      <div class="txt-intro mt-2 ">{{ __('change_password') }}</div>

      <form @submit="handleSubmit" class="card-body mt-2 mb-0">
        <input-float type="password" required v-model="form.password" :title="__('password')" />
        <input-float type="password" required v-model="form.password_confirmation" :title="__('repeat_password')" />
        <div class="form-group mb-0">
          <btn block type="submit">{{__('submit')}}</btn>
        </div>
      </form>
      <div class="text-center mt-2">
        <strong><inertia-link href="/login" preserve-scroll>{{ __('return_to_login') }}</inertia-link></strong>
      </div>
    </div>
</template>

<script>
export default
{

    name: "ResendEmail",
    props:
    {
        token: String
    },
    data()
    {
        return {
            form:
            {
                password: "",
                password_confirmation: ""
            }
        }
    },
    methods:
    {
        handleSubmit()
        {
            event.preventDefault()
            this.$inertia.post( "/password/token/" + this.token, this.form )
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
